import React, { ReactNode } from 'react';
import {
  LayoutChangeEvent,
  Pressable,
  StyleSheet,
  Text,
  View,
} from 'react-native';
import { Colors } from '../../../themes';
import { Icon } from '../icons';
import { tokens } from '../tokens';

export interface PanelHeaderProps {
  title: string;
  count?: number;
  onBackPress?: () => void;
  showBackButton?: boolean;
  rightActions?: ReactNode;
  rightLinkText?: string;
  onRightLinkPress?: () => void;
  showRightLink?: boolean;
  onTitleLayout?: (event: LayoutChangeEvent) => void;
  backButtonTestID?: string;
  rightLinkTestID?: string;
}

export const PanelHeader: React.FC<PanelHeaderProps> = ({
  title,
  count,
  onBackPress,
  showBackButton = false,
  rightActions,
  rightLinkText,
  onRightLinkPress,
  showRightLink = false,
  onTitleLayout,
  backButtonTestID,
  rightLinkTestID,
}) => {
  return (
    <View style={styles.header}>
      <View style={styles.headerLeft} onLayout={onTitleLayout}>
        {showBackButton && (
          <Pressable
            style={styles.backButton}
            onPress={onBackPress}
            testID={backButtonTestID}
          >
            <Icon name="Arrow Left" size={20} color={Colors.black} />
          </Pressable>
        )}
        <Text style={styles.titleText} numberOfLines={1}>
          {title}
          {count !== undefined && (
            <Text style={styles.countText}> ({count})</Text>
          )}
        </Text>
      </View>
      {showRightLink && rightLinkText && onRightLinkPress && (
        <Pressable
          style={styles.rightLink}
          onPress={onRightLinkPress}
          testID={rightLinkTestID}
        >
          <Text style={styles.titleText}>{rightLinkText}</Text>
          <Icon name="Arrow Right" size={20} color={Colors.black} />
        </Pressable>
      )}
      {rightActions && <View style={styles.headerActions}>{rightActions}</View>}
    </View>
  );
};

const styles = StyleSheet.create({
  header: {
    height: 56,
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    marginBottom: 2,
    backgroundColor: Colors.brand.white,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: tokens.spacing.lg,
    gap: tokens.spacing.sm,
  },
  headerLeft: {
    flexShrink: 1,
    minWidth: 0,
    flexDirection: 'row',
    alignItems: 'center',
    overflow: 'hidden',
  },
  backButton: {
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: tokens.spacing.xs,
  },
  titleText: {
    ...tokens.typography.body.mediumEmphasised,
    color: Colors.black,
    flexShrink: 1,
  },
  countText: {
    ...tokens.typography.body.small,
    color: Colors.slate[400],
  },
  rightLink: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: tokens.spacing.xs,
    flexShrink: 0,
  },
  headerActions: {
    flexGrow: 1,
    flexShrink: 0,
    flexBasis: 'auto',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: tokens.spacing.md,
  },
});
